import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';

const mapState = ({ results, user, searchMenu }: StateType) => ({
  loaded: results.loaded,
  searchLoading: results.searchLoading,
  query: results.query,
  trialExpired: user.trialExpired,
  quotaExceeded: user.quotaExceeded,
  isOpen: searchMenu.isOpen,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
